import { useTheme, useMediaQuery } from "@material-ui/core";

export const useIsMediumScreen = ( ) => {
  const theme = useTheme();
  return useMediaQuery( theme.breakpoints.up( 'sm' ) );
}

export default useIsMediumScreen;